import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const objections = ['This is not a random collection of drills copied from the internet.', 'This is not a theoretical manual that leaves you wondering how to apply it.', 'This is not a one-event program that ignores the rest of Track & Field.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-mist relative overflow-hidden border-y border-mist-dark" data-id="element-231" data-mp="z14mkngsul6d">
      <div className="max-w-4xl mx-auto text-center" data-id="element-232" data-mp="u29wr1kezwcr">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-233" data-mp="u3uq4nuzt991">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/15 text-gold-dark mb-5" data-id="element-234" data-mp="142k96jymkzqv">
            <span className="text-2xl" data-id="element-235" data-mp="2ffwfr2lrrwgq">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-navy" data-id="element-236" data-mp="2ffcy7n017a38">
            The Complete Track &amp; Field Coaching System for Coaches Worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold-solid mb-3" data-id="element-237" data-mp="2gth1z8mutv28">
            Track &amp; Field Coach Ready — A Complete 7-Volume Professional Coaching System
          </h3>
          <p className="text-base md:text-lg text-slate mb-10" data-id="element-238" data-mp="2pvqeg41onyi9">
            150 ready-to-run sessions · 5 professional bonuses · Beginner to advanced · Ready
            to use today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-239" data-mp="1x7m6fbvn39ce">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white p-6 rounded-2xl border border-mist-dark shadow-sm" data-id="element-240" data-mp="2265sdca8gl4r">
            {objections.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-241" data-mp="1ee8ktxdtgf9g">
                <X className="text-alert shrink-0 mt-1" size={18} data-id="element-242" data-mp="2hpnyzc0srtm3" />
                <p className="text-slate text-sm" data-id="element-243" data-mp="2csxkgt4n562s">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-navy p-6 rounded-2xl border border-gold/40 relative overflow-hidden" data-id="element-244" data-mp="2qi959sn8s7u1">
            <div className="flex items-start gap-3 relative z-10" data-id="element-245" data-mp="1tvcvlm1vm7i6">
              <Check className="text-gold-light shrink-0 mt-1" size={20} data-id="element-246" data-mp="27tuen6gu6vtr" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-247" data-mp="22tggcg51f08x">
                This is a complete professional coaching system designed to help you plan,
                coach, assess and develop athletes across the major Track &amp; Field
                disciplines.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}